import { apiSlice } from './apiSlice';

export const contactUsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Send new contact message
    sendContactMessage: builder.mutation({
      query: (data) => ({
        url: '/api/contactus/new', // Changed to match the others
        method: 'POST',
        body: data,
        timeout: 10000
      }),
      invalidatesTags: ['ContactUs'],
    }),
    
    // Fetch all contact messages (for admin)
    getContactMessages: builder.query({
      query: () => '/api/contactus',
      providesTags: ['ContactUs'],
    }),
    
    // Delete message
    deleteMessage: builder.mutation({
      query: (id) => ({
        url: `/api/contactus/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['ContactUs'],
    }),
    
    // Update message status
    updateMessageStatus: builder.mutation({
      query: (id) => ({
        url: `/api/contactus/status/${id}`,
        method: 'PUT',
      }),
      invalidatesTags: ['ContactUs'],
    }),
  }),
});

export const { 
  useSendContactMessageMutation,
  useGetContactMessagesQuery,
  useDeleteMessageMutation, 
  useUpdateMessageStatusMutation 
} = contactUsApiSlice;